
import { useEffect, useState } from "react";
import useProjects from "../../../hooks/useProjects";
import { FilledButton, OutlinedButton } from "../../common/Button";
import Lightbox from "../../common/Lightbox";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import useMyProjects from "../../../hooks/useMyProjects";
import TextInputArea from "../../common/TextInputArea";
import useProjectManagement from "../../../hooks/useProjectManagement";
import { ITask } from "../../../data_models/task";
import useTasks from "../../../hooks/useTasks";
import useConfig from "../../../hooks/useConfig";


interface RequestTaskRevisionLightboxProps {
    onClose: () => void;
    task: ITask;
    onUpdateTask: (updatedTask: ITask) => void;
}

const RequestTaskRevisionLightbox: React.FC<RequestTaskRevisionLightboxProps> = ({ onClose, task, onUpdateTask }) => {

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const { addRevisionToTask } = useTasks();
    const { config } = useConfig();

    const { addSuccessNotification, addErrorNotification } = useDisplayNotifications();

    const onApprove = async () => {

        setLoading(true);
        try {
            const updatedTask = await addRevisionToTask(task._id!, message.trim());
            onUpdateTask(updatedTask);
            addSuccessNotification(`Successfully sent revision for ${task.title}.`);
        } catch (error: any) {
            addErrorNotification(error.message, "Could not send revision");
        }
        setLoading(false);
        onClose();
    }

    return (
        <Lightbox
            header="Request a Revision"
            onCancel={onClose}
            onConfirm={onApprove}
            loadingConfirm={loading}
            disabledConfirm={!message.trim()}
            content={
                <div className="flex flex-col items-start space-y-4" >
                    <p>Add a few notes to let the talent know what needs to be improved. You can send up to {config?.maxAmountOfTaskRevisions || 3} revision requests per task.</p>
                    <div className="w-full">
                        <TextInputArea
                            value={message.toString()}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                    </div>
                    
                </div>}
            onClose={onClose}
        />

    );
}

export default RequestTaskRevisionLightbox;